export const API_GATEWAY_NAME = Symbol('ApiGatewayName')

import { getCurrentSession } from '../lib/authentication'

export default (API, { apiGatewayUrl, region }) => {
  const config = {
    API: {
      endpoints: [
        {
          region,
          name: API_GATEWAY_NAME,
          endpoint: apiGatewayUrl,
          custom_header: async () => ({
            Authorization: (await getCurrentSession()).idToken,
          }),
        },
      ],
    },
  }

  API.configure(config)
}
